module.exports = __webpack_public_path__ + "img/leucania-loreyi.48a45d32.jpg";